<template>
   <div class="maintenance-message">
    <div class="container">
        <div class="panel-header">
        <div class="title">
            <hgroup>
            <h4>Undergoing Scheduled System</h4>
            <h2>Maintenance</h2>
            </hgroup>
        </div>
        <div class="subtitle">
            We’re working hard <br>
            improving our <br>
            infrastructure <br>
            to better serve <br>
            our community... <br>
            We’ll be back shortly!
        </div>
        </div>
        <div class="panel-content">
        <p>Our systems are currently undergoing some scheduled maintenance to will help us improve the overall performance of the platform.  We’re conducting this process during off-peak hours in order to ensure a smooth transition.</p>
        <p>All services will resume immediately after the maintenance window. We appreciate your patience and understanding. As always, if you have questions or issues, please submit them at <a href="mailto:support@playlister.club">support@playlister.club</a></p>
        </div>
        <div class="panel-footer">
        <img src="@/assets/img/pc_logo_dark.png" alt="Playlister club logo">
        </div>
    </div>

    </div>
</template>

<script>


export default {
  name: 'MaintenanceShutdownModal',
  components: {

  },
  /* props:{
      playlister: {type: Object, default: {
        dbUserId:'',
        Name:'',
        Image:'',
        UserTier:'',
        AR:'',
        Followers:'',
        Playlists:'',
        SpotifyUserId:'',
        SignedOn:'',
        LastInteractionOn:'',
        LastInteractionType:'',
        LastInteractionSpotifySongId:'',
        LastInteractionSongName:'',
        LastInteractionSongImage:'',
        LastInteractionSongDuration:'',
        LastInteractionSongPreviewURL:'',
        LastInteractionSongSpotifyArtistId:'',
        LastInteractionSongSpotifyArtistName:'',
        BanId:'',
      }}
  },
  */
  data() {
    return {

    };
  },
  computed: {


  },
  watch: {


  },
  methods: {


  },
  beforeMount() {

  },
  mounted() {
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "@/assets/scss/variables.scss";
.maintenance-message{
  position: fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  display:flex;
  flex-flow: column nowrap;
  place-content: center;
  align-items: center;
  z-index: 99999999;
  .container{
    background-color: $color-white;
    width:600px;
    min-height: 400px;
    border-radius: 10px;
  }
  .panel-header{
    background-color: #78151a;
    color: $color-white;
    background-image: url('~@/assets/img/maintenance_header.jpg');
    background-position: left bottom;
    background-repeat: no-repeat;
    height: 360px;
    display:flex;
    flex-flow: column nowrap;
    border-radius: 10px 10px 0 0;
    hgroup{
      padding-top: 1rem;
      *{
        line-height: 100%;
        margin:0;
        color: $color-white;
        text-transform: uppercase;
      }
      h2{
        font-weight: 800;
        font-size: 3.75rem;
        letter-spacing: 3px;
      }
      h4{
        font-size: 1.2rem;
        padding: 10px 0;
      }
    }
    .subtitle{
      text-align: right;
      flex:1;
      padding-right: 3rem;

      display:flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 500;
    }
  }
  .panel-content{
    padding: 3rem;
  }
  .panel-footer{
    background-color: $color-gray;
    padding: 1rem 0;
    border-radius: 0 0 10px 10px;
  }
}

</style>
